import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import icons from '../assets/icons'
import useLanguage from '../hooks/useLanguage'
import Cruise from '../types/Cruise'
import { getDateFormat } from '../utils/dates'
import CruisingStatus from './CruisingStatus'
import Image from './Image'

type Props = {
  pending: boolean

  cruise: Cruise

  shipName?: string

  setCruise: (cruise: Cruise) => void

  cleanItem: () => void
}

const queryParams = new URLSearchParams(window.location.search)
const isRoadShow = queryParams.get('roadShow') === 'true'

const CruiseItem: React.FC<Props> = ({
  pending,
  cruise,
  shipName,
  setCruise,
  cleanItem,
}: Props) => {
  const language = useLanguage()
  const { t } = useTranslation()

  const onClickPending = useCallback(() => {
    cleanItem()
    setCruise(cruise)
  }, [cruise, setCruise, cleanItem])

  return (
    <div className='modal--cruise--container' onClick={pending ? onClickPending : undefined}>
      <Image
        src={`${cruise.cruise_images[language]}`}
        alt='cruise_image'
        className='modal--cruise--image'
      />
      <div className='modal--cruise--content'>
        {pending && <CruisingStatus />}
        <p className='modal--cruise--content--all text'>
          {cruise.cruise_name[language]}
        </p>
        {shipName && (
          <p className='modal--cruise--content--all text text--size14'>
            {shipName}
          </p>
        )}
        <p className='modal--cruise--content--all text text--gray text--size14'>
          {getDateFormat(cruise.cruise_start, cruise.cruise_end, language)}
        </p>
        {pending ? (
          <div className='modal--cruise--cta modal--cruise--pending'>
            <img className='modal--cruise--icon' src={icons['arrow-right']} alt='' />
            <span className='sr-only'>{t('modal.showCruise')}</span>
          </div>
        ) : !isRoadShow ? (
          <a
            className='modal--cruise--cta modal--cruise--button modal--cruise--notroadshow'
            href={cruise.cruise_url}
            target='_blank'
            rel='noreferrer'
          >
            <img className='modal--cruise--icon' src={icons['arrow-right']} alt='' />
            <span className='sr-only'>{t('modal.more')}</span>
          </a>
        ) : null}
      </div>
    </div>
  )
}

export default CruiseItem
